import { useState } from 'react';
import { IconButton, Tooltip } from '@prenuvo/halo-foundation';
import { Phone } from '@prenuvo/halo-icon';

import { FCT } from '@/i18n';

import { PatientContactDialog } from './patient-contact-dialog';

export function PatientContact() {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  const handleContactDialogClose = (value: boolean) => {
    setIsContactDialogOpen(!value);
  };

  return (
    <>
      <Tooltip content={FCT.REPORTING.HEADER.CONTACT_DETAILS.LABEL.ICON} side="bottom">
        <IconButton
          aria-label={FCT.REPORTING.HEADER.CONTACT_DETAILS.LABEL.ICON}
          data-testid="patient-contact-details-button"
          icon={Phone}
          onClick={() => setIsContactDialogOpen(true)}
          size="sm"
          variant="text"
        />
      </Tooltip>
      <PatientContactDialog closeDialog={handleContactDialogClose} open={isContactDialogOpen} />
    </>
  );
}
